import React, {useEffect, useState} from 'react';
import {getPermisos} from '../../services';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Alert,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    FormControlLabel,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Theme,
    Typography,
    useMediaQuery,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Strings from '../../assets/strings';
import {agregarEditarRol, mostrarRolById} from "../../redux/reducers/rolesReducers";
import {MostrarError} from "../../components/MostrarError";
import TopBarDialog from "../../components/topBar/TopBarDialog";
import {useLocation, useNavigate} from "react-router-dom";
import {hasPermissionTo, nullToEmptyString, PERSMISOS, translateText} from "../../helpers";
//import {SlideLeft} from "../../components/transitions";
import StyledCheckbox from "../../components/StyledCheckbox";
import LoadingProgress from "../../components/LoadingProgress";
import {
    AccessAlarmsOutlined,
    CheckBoxOutlineBlankOutlined,
    CheckBoxOutlined,
    DisabledByDefaultOutlined,
    ExpandMore,
    HttpsOutlined
} from '@mui/icons-material';
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {IPermiso, IRol, IRolPermiso} from "../../redux/types/IRoles";
import {TimeInput} from "../../components/CustomTextField";
import moment from "moment/moment";
import {DIAS_SEMANA, getValueString} from "../../helpers/CONSTANTES";

const useStyles = makeStyles((theme:Theme) => ({
    btnTopCont:{
        // overflow:"auto",
        // marginBottom:theme.spacing(1),
        borderBottom: "1px solid #d4d4d4",
        position: "sticky",
        //top: "65px",
        background: "#faf9f8",
        zIndex: 4,

        "&>nav":{
            display:"flex",
            justifyContent: "center",
            //   minWidth: 912,
            "& button":{
                lineHeight: "14px",
                height: 32,
                fontSize: 11,
                fontWeight:"bold",
                color:"#000000",
                borderRadius:0,
                margin: 4,


                "&.active":{
                    background:theme.palette.primary.dark,
                    color:theme.palette.common.white
                }
            }
        },
        [theme.breakpoints.down('md')]: {
            marginTop:0,
            //     background: "#e6e6e6",
            padding: 1,
            top: "50px",
        },


        "&+div div[class*='topHeader']":{
            position: "sticky",
            top: "65px",
            zIndex: 3,
            background: "#ededed",
        }
    },
    cbRow:{
        borderBottom: "1px solid" +theme.palette.grey[200],
        "& label":{
            width: "100%",
        },
    },
    accordion: {
        margin: "0 !important",
        boxShadow: "none",
        borderBottom: "1px solid" +theme.palette.grey[200],
    },
    accordionDetails:{
        padding: 0,
        paddingBottom: 8,
    },
    accordionSummaryRoot: {
        minHeight:"0 !important",
        padding: 0,
    },

    accordionSummaryContent: {
        margin: "0 !important",
    }
}));
const defaultHorario = () => {

  return [1,2,3,4,5,6,0].map(dia => ({
      accion:undefined,
      diaSemana: dia,
      horaEntrada: "",
      horaSalida: "",
  }))
}
const initialState:IRol = {
    descripcion: "",
    rolesHorarios: defaultHorario()
};

function isValidDuration(start:string, end:string) {
    if(start && end){
        var duration = moment.duration(moment(end,'HH:mm:ss').diff(moment(start,'HH:mm:ss')));
        var minutes = duration.asMinutes();
        return minutes > 0
    }

    return true
}
function Crear() {
    const classes = useStyles();

    const {byId:rol, error, status } = useAppSelector(state => state.roles);
    const Dispatch = useAppDispatch();



    const navigate =useNavigate();
    const {state:urlState}:{state:any} = useLocation();

    const smVewport = useMediaQuery((theme:Theme)=>theme.breakpoints.down('md'));
    const [state, setState] = useState(initialState);
    const [permisos, setPermisos] = useState<IPermiso[]>([]);
    const [activeTab, setActiveTab] = useState<"permisos" | "horarios">("permisos");


    useEffect(() => {
        getPermisos()
            .then(({data}) => {
                setPermisos(data);
            })
    }, [setPermisos]);

    useEffect(()=>{
        if(urlState?.id) {
            Dispatch(mostrarRolById(+urlState.id))
            setState({...initialState, ...nullToEmptyString(urlState)});
        }
    },[urlState,setState, Dispatch])


    useEffect(() => {
        if(!!urlState?.id && !!rol?.id && rol?.id === parseInt(urlState?.id)) {

            let data: IRol = {...initialState, ...nullToEmptyString(rol)}

            let rolesHorarios = defaultHorario().map(item=>{
                let itemAdded = data.rolesHorarios?.find(e=>e.diaSemana === item.diaSemana);

                if(itemAdded){
                    return itemAdded
                }
                return item
            })

            setState({...data, rolesHorarios});

        }else {
            setState(initialState);
        }
    }, [setState, urlState, rol]);

    const includePermiso = (e:any, arrayPer:number[],parentPerId?:number)=> {
        if(state.registroDelSistema) return false
        const {name, checked } = e.target;
        const perId  = parseInt(name);

        const mergePermisos = [perId,...arrayPer]
        let permisosSelected:IRolPermiso[] = [...(state.rolesPermisos??[])];



        if(checked){
            if(mergePermisos.length){
                mergePermisos.forEach(eID=>{
                    if(!permisosSelected.find(p=>p.permisoId === eID)){
                        permisosSelected.push({
                            id:0,
                            permisoId:eID,
                            accion:1
                        })
                    }else{
                        permisosSelected = permisosSelected.map(ps=>{
                            if(ps.permisoId === eID){
                                return {...ps, accion: 0}
                            }
                            return ps
                        })

                    }
                })
            }

            if(parentPerId){
                if(!permisosSelected.find(p=>p.permisoId === parentPerId)){
                    permisosSelected.push({
                        id:0,
                        permisoId:parentPerId,
                        accion:1
                    })
                }else{

                    permisosSelected = permisosSelected.map(ps=>{
                        if(ps.permisoId === parentPerId){
                            return {...ps, accion: 0}
                        }
                        return ps
                    })

                }
            }

        } else{

            if(mergePermisos.length){
                mergePermisos.forEach(item => {
                    permisosSelected.forEach((per,index)=>{
                        if(per.permisoId === item && per.id > 0){
                            permisosSelected = permisosSelected.map(ps=>{
                                if(ps.permisoId === item){
                                    return {...ps, accion: 3}
                                }
                                return ps
                            })
                        }else if(per.permisoId === item){
                            permisosSelected.splice(index, 1);
                        }
                    })

                })
            }
        }

        setState({ ...state, rolesPermisos:[...permisosSelected] });
    };
    const handleSubmit = () => {
        let data = {...state}

        let rolesPermisos = [...(data.rolesPermisos??[])];
        rolesPermisos = rolesPermisos.filter(p=>p.accion !== 3) //eliminar los permisos con accion 3
        rolesPermisos = rolesPermisos.map(p=>({id: p.id, permisoId: p.permisoId})) // solo enviar estas dos props


        let rolesHorarios = data.rolesHorarios?.filter(p=>(p.accion !== undefined && p.accion !== 0 && !!p.horaEntrada && !!p.horaSalida)) //eliminar los horarios con accion 3, 0 o undefined

        data = {...data, rolesPermisos, rolesHorarios }


        Dispatch(agregarEditarRol(data));
    };
    const duplicar = () =>{
        let copyState:IRol = {...state,descripcion: state.descripcion + " - "+Strings.copia, registroDelSistema: false, id:undefined }
        return setState(copyState);
    }
    const handleChangeTime = (dia:number, prop:string, value: string) => {
        if(state.registroDelSistema) return false

        let rolesHorarios = [...(state.rolesHorarios??[])];

        rolesHorarios = rolesHorarios.map(e=>{
            if(e.diaSemana === dia){
                let found = {...e};
                (found as any)[prop] = value


                if(found.accion === undefined){
                    found.accion = 1;
                }else if(found.accion === 0){
                    found.accion = 2;
                }


                return found
            }
            return e
        })


        setState(prevState => ({...prevState, rolesHorarios}))



    }
    const crearTime = (dia:number) => {
        if(state.registroDelSistema) return false

        let rolesHorarios = [...(state.rolesHorarios??[])];
        rolesHorarios = rolesHorarios.map(e=>{
            if(e.diaSemana === dia){
                let found = {...e}
                if(found.accion === 1){
                    found.accion = undefined;
                    found.horaEntrada = "";
                    found.horaSalida = "";

                }else if(found.accion === 2 || found.accion === 0){
                    found.accion = 3;
                }else if(found.accion === 3){
                    found.accion = 2;
                }
                else if(found.accion === undefined){
                    found.accion = 1;
                    found.horaEntrada = "07:00:00";
                    found.horaSalida = "17:00:00";
                }


                return found
            }
            return e
        })

        setState(prevState => ({...prevState, rolesHorarios}))

    }
    return (
        <>
            <Dialog open={Boolean(urlState && urlState.hasOwnProperty("id"))}
                    onClose={()=>navigate(-1)}
                    maxWidth={"md"}
                    fullScreen={smVewport}
                    fullWidth>
                {/*{...(smVewport ? {TransitionComponent: SlideLeft}:{})}*/}

                <TopBarDialog nofullScreen={false} title={(!!state.id ? Strings.actualizar : Strings.agregar+" "+Strings.nuevo)+" Rol"} onClose={()=>navigate(-1)}/>

                <div className={classes.btnTopCont}>
                    <nav>
                        <Button startIcon={<HttpsOutlined/>}  onClick={()=>setActiveTab("permisos")} className={activeTab === "permisos"?"active":""}>{translateText("permisos")}</Button>
                        <Button startIcon={<AccessAlarmsOutlined/>}  onClick={()=>setActiveTab("horarios")} className={activeTab === "horarios"?"active":""}>{translateText("horarios")}</Button>
                    </nav>
                </div>
                {state.registroDelSistema &&
                    <>
                        <Alert icon={false} color={"warning"}
                               action={
                                   <Button color="inherit" size="small" onClick={duplicar}>
                                       {Strings.duplicar}
                                   </Button>
                               }
                        >
                            {Strings.registroDelSistemaMsj}
                        </Alert>
                        <br/>
                    </>
                }

                <DialogContent sx={activeTab === "horarios" ? {padding:0}:{padding:2}}>
                    {error && <MostrarError errors={error}/>}
                    {status === "loading" && <LoadingProgress />}
                    {activeTab === "permisos" &&
                        <form>
                            <Grid container spacing={1}>
                                <Grid  item xs={12}>
                                    <TextField
                                        label={Strings.descripcion}
                                        value={state.descripcion}
                                        onChange={(e:any)=>setState({ ...state, "descripcion": e.target.value })}
                                        inputProps={{maxLength: 50}}
                                        required
                                        fullWidth
                                    />
                                </Grid>
                                <Grid  item xs={12}>
                                    {!!permisos.length && permisos.map(per =>
                                        (per.actions && per.actions.length > 0) ? (
                                            <Accordion key={per.id} className={classes.accordion} defaultExpanded>
                                                <AccordionSummary expandIcon={<ExpandMore/>}
                                                                  classes={{
                                                                      root:classes.accordionSummaryRoot,
                                                                      content:classes.accordionSummaryContent}}>

                                                    <FormControlLabel
                                                        sx={{textTransform: "capitalize"}}
                                                        checked={!!state.rolesPermisos?.find(p=>p.permisoId===per.id && p.accion !== 3)}

                                                        //checked={state.rolesPermisos?.indexOf(per.permisoId) !== -1}
                                                        onClick={(event) => event.stopPropagation()}
                                                        onFocus={(event) => event.stopPropagation()}
                                                        onChange={(e)=>includePermiso(e,per.actions?.map((acc)=>acc.key!) ?? [])}
                                                        control={<Checkbox  name={per.id?.toString()}/>}
                                                        label={translateText(per.name)}
                                                    />

                                                </AccordionSummary>
                                                <AccordionDetails className={classes.accordionDetails}>
                                                    <Grid container>
                                                        {per.actions?.map((acc:any)=>
                                                            <Grid item  xs={6} md={4} key={acc.key}>
                                                                <FormControlLabel
                                                                    sx={{textTransform: "capitalize"}}
                                                                    control={
                                                                        <StyledCheckbox
                                                                            checked={!!state.rolesPermisos?.find(p=>p.permisoId===acc.key && p.accion !== 3)}

                                                                            //checked={state.rolesPermisos?.indexOf(acc.key) !== -1}
                                                                            onChange={(e:any)=>includePermiso(e,[],per.id)}
                                                                            color="primary"
                                                                            inputProps={{
                                                                                'aria-label': 'primary checkbox',
                                                                                name: acc.key?.toString(), //+ '_' + acc.key,
                                                                            }}
                                                                        />
                                                                    }
                                                                    label={translateText(acc.value)}
                                                                />
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                </AccordionDetails>
                                            </Accordion>
                                        ):(
                                            <div className={classes.cbRow} key={per.id} >
                                                <FormControlLabel
                                                    checked={!!state.rolesPermisos?.find(p=>p.permisoId===per.id && p.accion !== 3)}
                                                    onChange={(e)=>includePermiso(e,per.actions?.map((acc)=>acc.key!) ?? [])}
                                                    control={<Checkbox  name={per.id?.toString()}/>}
                                                    label={per.name}
                                                />
                                            </div>
                                        )
                                    )}
                                </Grid>
                            </Grid>
                        </form>
                    }
                    {activeTab === "horarios" &&
                        <TableContainer>
                            <Table aria-label="simple table" className={"hasOnclick"}>
                                <TableHead>
                                    <TableRow style={{textTransform:"uppercase"}}>
                                        <TableCell/>
                                        <TableCell>{Strings.dias}</TableCell>
                                        <TableCell>{translateText("horaDeEntrada")}</TableCell>
                                        <TableCell>{translateText("horaDeSalida")}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {/*{state.rolesHorarios?.map(item =>*/}
                                    {/*    <TableRow key={item.diaSemana} >*/}
                                    {/*        <TableCell> {item.diaSemana }</TableCell>*/}
                                    {/*        <TableCell> {formatDate(item.horaEntrada)}</TableCell>*/}
                                    {/*        <TableCell> {formatDate(item.horaSalida)}</TableCell>*/}
                                    {/*    </TableRow>*/}
                                    {/*)}*/}

                                    {state.rolesHorarios?.map(item =>
                                        <TableRow key={item.diaSemana} className={!isValidDuration(item.horaEntrada, item.horaSalida)? "bg-red": ""}>
                                            <TableCell sx={{textAlign:"center"}}>
                                                {hasPermissionTo(PERSMISOS.pagosEliminar) &&
                                                    <IconButton

                                                        size={"small"}
                                                        onClick={(e)=>{
                                                            e.stopPropagation();
                                                            crearTime(item.diaSemana)
                                                        }}
                                                        >
                                                        {(item.accion === 0 || item.accion === 1 || item.accion === 2 ) ?(
                                                            <CheckBoxOutlined color={"primary"}/>
                                                        ):(
                                                            <>
                                                                {item.accion === 3 ?(
                                                                    <DisabledByDefaultOutlined color={"error"}/>
                                                                ):(
                                                                    <CheckBoxOutlineBlankOutlined />
                                                                )}
                                                            </>
                                                        )}
                                                    </IconButton>
                                                }


                                            </TableCell>
                                            <TableCell style={{textTransform:"capitalize"}}>
                                                {getValueString(DIAS_SEMANA, item.diaSemana)}

                                                {!!item.horaEntrada && !!item.horaSalida  &&
                                                    <>
                                                        {!isValidDuration(item.horaEntrada, item.horaSalida) &&
                                                            <Typography component={"div"} variant={"caption"} color={"white"}>Tiempo invalido.</Typography>
                                                        }

                                                    </>
                                                }
                                            </TableCell>
                                            <TableCell>
                                                {/*// @ts-ignore*/}
                                                <TimeInput
                                                    value={item.horaEntrada} //formatDate(new Date(),"YYYY-MM-DD")
                                                    onChange={(val:string)=>handleChangeTime(item.diaSemana, "horaEntrada", val)}
                                                    disabled={item.accion === undefined || item.accion === 3}
                                                    maxTime={item.horaSalida ? moment(item.horaSalida,'HH:mm:ss').add(-1, "hour") : undefined}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                {/*// @ts-ignore*/}
                                                <TimeInput
                                                    value={item.horaSalida} //formatDate(new Date(),"YYYY-MM-DD")
                                                    onChange={(val:string)=>handleChangeTime(item.diaSemana, "horaSalida", val)}
                                                    disabled={item.accion === undefined || item.accion === 3 || !item.horaEntrada}
                                                    minTime={item.horaEntrada ? moment(item.horaEntrada,'HH:mm:ss').add(1, "hour")  : undefined}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    )}


                                </TableBody>
                            </Table>
                        </TableContainer>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>navigate(-1)} color="warning" variant={"text"}>{Strings.cancelar}</Button>
                    <Button onClick={handleSubmit} color="primary" disabled={status === "loading" || state.registroDelSistema} variant={"outlined"}>
                        {!!state?.id ? Strings.actualizar : Strings.guardar}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
export default Crear;
